import * as ActionTypes from "../actions/ActionTypes";
import initialState from "./initialState";

export default function issueReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.INITIALIZE:
			return action.issues;
		
		case ActionTypes.ADD_ISSUE:
			return [
				Object.assign({}, action.issue),
				...state
			];

		case ActionTypes.EDIT_ISSUE:
			let updatedState1 = state.filter((issue) => issue.id !== action.issue.id);
			console.log("action ", action);
			return [
				Object.assign({}, action.issue),
				...updatedState1
			];
		
		case ActionTypes.DELETE_ISSUE:
			let updatedState = state.filter((issue) => issue.id !== action.id);
			return [
				...updatedState,
			];

		default:
			return state;
	}
}